import { Helpers } from '../../helpers';
import { IStandardConfiguration } from '../../interfaces/istandard-configuration';
import { ProjectTemplate } from '../project-template';
import { ProjectType } from '../project-type';
import { StandardConfigurationAssetTeam } from '../standard-configuration-asset-team';
import { StandardConfigurationConstructionType } from '../standard-configuration-construction-type';
import { StandardConfigurationDetail } from '../standard-configuration-detail';
import { StandardConfigurationProjectSubType } from '../standard-configuration-project-sub-type';

export class StandardConfigurationBase {
  StandardConfigurationId: number;
  Name: string | null;
  ProjectTypeId: number | null;
  IsActive: boolean;
  LastUpdatedDate: Date | null;
  LastUpdatedUser: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  StandardConfigurationAssetTeams_StandardConfiguration?: Array<StandardConfigurationAssetTeam> | null;
  StandardConfigurationConstructionTypes_StandardConfiguration?: Array<StandardConfigurationConstructionType> | null;
  StandardConfigurationDetails_StandardConfiguration?: Array<StandardConfigurationDetail> | null;
  StandardConfigurationProjectSubTypes_StandardConfiguration?: Array<StandardConfigurationProjectSubType> | null;
  ProjectTemplates_DefaultStandardConfiguration?: Array<ProjectTemplate> | null;
  ProjectType?: ProjectType;

  constructor(item?: IStandardConfiguration) {
    if (item) {

      this.StandardConfigurationId = item.StandardConfigurationId;
      this.Name = item.Name;
      this.ProjectTypeId = item.ProjectTypeId;
      this.IsActive = item.IsActive;
      this.LastUpdatedDate = item.LastUpdatedDate ? new Date(item.LastUpdatedDate) : null;
      this.LastUpdatedUser = item.LastUpdatedUser;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.StandardConfigurationAssetTeams_StandardConfiguration = Helpers.createClassArray(StandardConfigurationAssetTeam, item.StandardConfigurationAssetTeams_StandardConfiguration);
      this.StandardConfigurationConstructionTypes_StandardConfiguration = Helpers.createClassArray(StandardConfigurationConstructionType, item.StandardConfigurationConstructionTypes_StandardConfiguration);
      this.StandardConfigurationDetails_StandardConfiguration = Helpers.createClassArray(StandardConfigurationDetail, item.StandardConfigurationDetails_StandardConfiguration);
      this.StandardConfigurationProjectSubTypes_StandardConfiguration = Helpers.createClassArray(StandardConfigurationProjectSubType, item.StandardConfigurationProjectSubTypes_StandardConfiguration);
      this.ProjectTemplates_DefaultStandardConfiguration = Helpers.createClassArray(ProjectTemplate, item.ProjectTemplates_DefaultStandardConfiguration);
      this.ProjectType = new ProjectType(item.ProjectType);
    }
  }
}